import { render, staticRenderFns } from "./RetentionUser.vue?vue&type=template&id=471ff719&scoped=true&"
import script from "./RetentionUser.vue?vue&type=script&lang=js&"
export * from "./RetentionUser.vue?vue&type=script&lang=js&"
import style0 from "./RetentionUser.vue?vue&type=style&index=0&id=471ff719&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ff719",
  null
  
)

export default component.exports